export default __webpack_public_path__ + "static/media/0xd3b71117e6c1558c1553305b44988cd944e97300.8c4c204f.png";